import { getFromBreakpoint } from '@vakantiesnl/components/src/styles/breakpoints';
import { makeStyles } from '@vakantiesnl/components/src/styles/themes/themewrapper';

export const useCustomStyles = makeStyles()((theme) => ({
	priceCard: {
		display: 'flex',
		flexDirection: 'column',
		border: 'none',
		borderRadius: theme.borderRadius.rounded,

		[getFromBreakpoint('md')]: {
			border: theme.priceBlock.border.default,
			padding: theme.spacing.medium,
		},

		['&:empty']: {
			display: 'none',
		},
	},
	zooverDealContainer: {
		// * -1 to create negative margin
		marginLeft: `calc(${theme.spacing.small} * -1 )`,
		marginRight: `calc(${theme.spacing.small} * -1 )`,
		marginBottom: theme.spacing.small,

		[getFromBreakpoint('md')]: {
			margin: `calc((${theme.spacing.medium} + ${theme.border.thin}) * -1 )`,
			marginBottom: theme.spacing.medium,
		},
	},
	priceContainer: {
		marginBottom: theme.spacing.medium,
	},
	price: {
		color: theme.priceBlock.price.color,
	},
	placeholderContainer: {
		backgroundColor: theme.palette.yellow[20],
		padding: theme.spacing.medium,
		minHeight: `calc(117px - 2*${theme.spacing.medium})`, // Fixed height so it's mimicking the most common usecase.
	},
	placeHolderDateContainer: {
		backgroundColor: theme.palette.neutral[5],
	},
	placeholderText: {
		color: theme.palette.yellow[160],
	},
	prices: {
		display: 'flex',
		flexDirection: 'row',
		justifyContent: 'space-between',
		alignItems: 'center',
	},
	checkPriceButton: {
		width: '100%',
	},
	offerSummaryContainer: {
		display: 'flex',
		flexDirection: 'column',
	},
	hybridAdlinkBlockTitle: {
		marginBottom: theme.spacing.xxsmall,
	},
	adlinksContainer: {
		gap: 0,
	},
	originalPricePerAdult: {
		font: theme.priceBlock.priceBefore.font,
		color: theme.priceBlock.originalPrice.color,
		textDecorationLine: 'line-through',
		margin: 0,
	},
	storybookContainer: {
		maxWidth: '384px',
	},
	adlinksToggleTile: {
		cursor: 'pointer',
		display: 'flex',
		justifyContent: 'space-between',
		alignItems: 'center',
	},
	adlinksToggleDivider: {
		marginBottom: 0,
	},
	favoriteButton: {
		color: theme.button.secondary.label.color.default,

		'&&': {
			backgroundColor: theme.palette.neutral[0],
		},

		'&:hover': {
			borderColor: theme.button.secondary.border.color.default,
			color: theme.body.foreground.color.mandatory,
		},
	},
	favoriteButtonActive: {
		color: theme.body.foreground.color.mandatory,

		'&:hover': {
			color: 'initial',
		},
	},
	buttonContainer: {
		display: 'flex',
		justifyContent: 'column',
		gap: theme.spacing.xxsmall,
	},
}));
